"use client";

import { useCompositeGroup } from "../__chunks/YORGHBM4.js";
import "../__chunks/36LIF33V.js";
import "../__chunks/7HVFURXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-group.tsx
var TagName = "div";
var useMenuGroup = createHook(function useMenuGroup2(props) {
  props = useCompositeGroup(props);
  return props;
});
var MenuGroup = forwardRef(function MenuGroup2(props) {
  var htmlProps = useMenuGroup(props);
  return createElement(TagName, htmlProps);
});
export { MenuGroup, useMenuGroup };